import React, { useState, useEffect } from "react";

export default function PWAInstallPopup({ onInstallClick }) {
  const cookieName = "pwa_popup_shown";

  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
  };

  const setSessionCookie = (name, value) => {
    document.cookie = `${name}=${value}; path=/`;
  };

  const [showPopup, setShowPopup] = useState(false);
  const [isInstallHovered, setIsInstallHovered] = useState(false);
  const [isCloseHovered, setIsCloseHovered] = useState(false);

  useEffect(() => {
    if (!getCookie(cookieName)) {
      setShowPopup(true);
    }
  }, []);

  const handleClose = () => {
    setShowPopup(false);
    setSessionCookie(cookieName, "true"); 
  };

  const handleInstall = () => {
    onInstallClick?.();
    setShowPopup(false);
    setSessionCookie(cookieName, "true"); 
  };

  if (!showPopup) return null;

  return (
    <div style={popupStyle}>
      <h3 style={headingStyle}>Install this app?</h3>
      <p style={paragraphStyle}>
        You can install this app to use it like a native mobile app.
      </p>
      <div style={buttonContainerStyle}>
        <button
          style={{
            ...installButtonStyle,
            backgroundColor: isInstallHovered ? "#5c0eff" : "#4a00e0",
          }}
          onClick={handleInstall}
          onMouseEnter={() => setIsInstallHovered(true)}
          onMouseLeave={() => setIsInstallHovered(false)}
        >
          Install
        </button>
        <button
          style={{
            ...closeButtonStyle,
            backgroundColor: isCloseHovered ? "#f5f5f5" : "transparent",
            color: isCloseHovered ? "#333" : "#666",
          }}
          onClick={handleClose}
          onMouseEnter={() => setIsCloseHovered(true)}
          onMouseLeave={() => setIsCloseHovered(false)}
        >
          Close
        </button>
      </div>
    </div>
  );
}

const popupStyle = {
  position: "fixed",
  bottom: "20px",
  right: "20px",
  padding: "20px",
  backgroundColor: "var(--cards-background)",
  border: "none",
  borderRadius: "16px",
  boxShadow: "0 8px 16px rgba(0, 0, 0, 0.15)",
  zIndex: 9999,
  maxWidth: "320px",
  width: "90%",
  transition: "all 0.3s ease",
};

const headingStyle = {
  margin: "0 0 8px 0",
  fontSize: "18px",
  fontWeight: "600",
  color: "var(--header__color)",
  lineHeight: "1.4",
};

const paragraphStyle = {
  margin: "0 0 16px 0",
  fontSize: "14px",
  color: "var(--header__color)",
  lineHeight: "1.5",
  opacity: 0.8,
};

const buttonContainerStyle = {
  display: "flex",
  gap: "12px",
  justifyContent: "flex-end",
};

const installButtonStyle = {
  padding: "8px 16px",
  color: "#ffffff",
  border: "none",
  borderRadius: "8px",
  fontSize: "14px",
  fontWeight: "500",
  cursor: "pointer",
  transition: "background-color 0.2s ease, transform 0.1s ease",
  outline: "none",
};

const closeButtonStyle = {
  padding: "8px 16px",
  backgroundColor: "transparent",
  border: "1px solid var(--border__color)",
  borderRadius: "8px",
  fontSize: "14px",
  fontWeight: "500",
  cursor: "pointer",
  transition: "all 0.2s ease",
  outline: "none",
  color: "var(--header__color)",
};
